import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DepartmentFilterMatrix = ({ selectedDepartments, onChange }) => {
  const departments = [
    { id: 'HR', name: 'Human Resources', icon: 'Users' },
    { id: 'Finance', name: 'Finance', icon: 'DollarSign' },
    { id: 'Operations', name: 'Operations', icon: 'Cog' },
    { id: 'IT', name: 'Information Technology', icon: 'Laptop' },
    { id: 'Sales', name: 'Sales', icon: 'TrendingUp' },
    { id: 'Marketing', name: 'Marketing', icon: 'Megaphone' },
    { id: 'Legal', name: 'Legal', icon: 'Scale' }
  ];

  const handleToggle = (deptId) => {
    if (selectedDepartments?.includes(deptId)) {
      onChange(selectedDepartments?.filter(d => d !== deptId));
    } else {
      onChange([...selectedDepartments, deptId]);
    }
  };

  const handleSelectAll = () => {
    if (selectedDepartments?.length === departments?.length) {
      onChange([]);
    } else {
      onChange(departments?.map(d => d?.id));
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between mb-3">
        <label className="block text-sm font-medium text-foreground">
          Filter by Departments
        </label>
        <Button
          variant="ghost"
          size="xs"
          onClick={handleSelectAll}
        >
          {selectedDepartments?.length === departments?.length ? 'Deselect All' : 'Select All'}
        </Button>
      </div>

      <div className="grid grid-cols-1 gap-2">
        {departments?.map((dept) => (
          <div
            key={dept?.id}
            className="bg-muted/30 rounded-lg p-2 hover:bg-muted/50 transition-colors"
          >
            <div className="flex items-center gap-2">
              <Checkbox
                checked={selectedDepartments?.includes(dept?.id)}
                onChange={() => handleToggle(dept?.id)}
              />
              <Icon name={dept?.icon} size={16} color="var(--color-primary)" />
              <span className="text-sm text-foreground">{dept?.name}</span>
            </div>
          </div>
        ))}
      </div>

      {selectedDepartments?.length > 0 && (
        <div className="mt-3 p-2 bg-primary/10 rounded-md">
          <p className="text-xs text-primary font-medium">
            {selectedDepartments?.length} department{selectedDepartments?.length > 1 ? 's' : ''} selected
          </p>
        </div>
      )}
    </div>
  );
};

export default DepartmentFilterMatrix;